var _defs, _g, _g2, _path, _path2, _path3, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotFound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 308.004,
    height: 353.235,
    viewBox: "0 0 308.004 353.235",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154,0A154,154,0,0,1,308,154c0,34.106-5.662,86.883-24.5,112.5-9,6-1.648,23.7-64.5,37-28.2,8.461-48,6-75,2.5s-51-20.5-61-26C-2.052,280,0,239.052,0,154A154,154,0,0,1,154,0Z",
    transform: "translate(23 163)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.551,
    y1: 0.882,
    x2: 0.477,
    y2: 0.285,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0079fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.097,
    stopColor: "#009bfd",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.285,
    stopColor: "#009bfd",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546,
    stopColor: "#009bfd",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.868,
    stopColor: "#ffe6ea",
    stopOpacity: 0.157
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M333.748,166.053a4.9,4.9,0,0,1-3.036,6.14l-45.338,14.467a4.717,4.717,0,0,1-5.883-3.294L248.349,80.187a4.9,4.9,0,0,1,3.036-6.14L296.723,59.58a4.718,4.718,0,0,1,5.883,3.294Z",
    transform: "translate(-248.126 -59.369)",
    fill: "#def2ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 0.818,
    y1: -1.234,
    x2: 0.818,
    y2: -0.642,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.191,
    stopColor: "#fff",
    stopOpacity: 0.988
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325,
    stopColor: "#fff",
    stopOpacity: 0.953
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.441,
    stopColor: "#fff",
    stopOpacity: 0.894
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547,
    stopColor: "#fff",
    stopOpacity: 0.808
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.646,
    stopColor: "#fff",
    stopOpacity: 0.694
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#fff",
    stopOpacity: 0.557
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.831,
    stopColor: "#fff",
    stopOpacity: 0.396
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.916,
    stopColor: "#fff",
    stopOpacity: 0.212
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.997,
    stopColor: "#fff",
    stopOpacity: 0.008
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.831,
    y1: 0.066,
    x2: 0.193,
    y2: 0.462,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.946,
    y1: -0.017,
    x2: 0.283,
    y2: 0.387,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.93,
    y1: -0.004,
    x2: 0.202,
    y2: 0.422,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 1.048,
    y1: -0.075,
    x2: 0.282,
    y2: 0.363,
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 0.967,
    y1: -0.065,
    x2: 0.196,
    y2: 0.374,
    xlinkHref: "#d"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26 -95)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.996 -28)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.004 289.671)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.66)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M307.606,246.4s37.263,87.415,172.69,59.936c115.513-23.438,64.886-140.413,4.988-112.431-49.416,23.086-93.438-4.282-107.333-14.568a54,54,0,0,0-20.79-9.537c-12.857-2.745-31.019-2.188-45.652,15.42C311.51,185.224,292.106,209.4,307.606,246.4Z",
    transform: "translate(-301.601 -126)",
    fill: "#def2ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 3.311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M641.1,188.735a4.473,4.473,0,1,0,2.229,5.921A4.474,4.474,0,0,0,641.1,188.735Z",
    transform: "translate(-371.534 -134.625)",
    fill: "none",
    stroke: "#dde3fd",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.488,344.774a4.473,4.473,0,1,0,2.229,5.921A4.473,4.473,0,0,0,306.488,344.774Z",
    transform: "translate(-281.556 -176.584)",
    fill: "none",
    stroke: "#dde3fd",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.7,117.3a2.428,2.428,0,1,1-2.428-2.427A2.428,2.428,0,0,1,389.7,117.3Z",
    transform: "translate(-304.325 -114.87)",
    fill: "#dde3fd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.133,351.737a2.428,2.428,0,1,1-2.427-2.427A2.428,2.428,0,0,1,630.133,351.737Z",
    transform: "translate(-368.978 -177.911)",
    fill: "#7a87ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.565,193.343a2.428,2.428,0,1,1-2.428-2.428A2.428,2.428,0,0,1,279.565,193.343Z",
    transform: "translate(-274.71 -135.319)",
    fill: "#d59afa"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.109 9.675)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 18.112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.967,157.43H297.182a4.54,4.54,0,0,1-4.541-4.54h0a4.541,4.541,0,0,1,4.541-4.541h18.786a4.54,4.54,0,0,1,4.54,4.541h0A4.54,4.54,0,0,1,315.967,157.43Z",
    transform: "translate(-292.641 -148.349)",
    fill: "#def2ff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.788 3.363)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.617,154.15a1.162,1.162,0,1,1-1.165-1.158A1.162,1.162,0,0,1,305.617,154.15Z",
    transform: "translate(-303.294 -152.961)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.433,154.129a1.162,1.162,0,1,1-1.165-1.158A1.162,1.162,0,0,1,312.433,154.129Z",
    transform: "translate(-305.127 -152.955)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.249,154.107a1.162,1.162,0,1,1-1.165-1.158A1.161,1.161,0,0,1,319.249,154.107Z",
    transform: "translate(-306.96 -152.949)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3 7)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-38 -13.552)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.611 -46.889) rotate(9)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(85.306 265.632)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 35.474)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.842,242.742l35.317-8.447c11.529-2.758,14.4-32.075,6.412-65.475s-23.814-58.246-35.343-55.489L87.91,121.779c7.434-1.778,16.655,7.918,24.409,23.989a158.264,158.264,0,0,1,10.935,31.5,158.257,158.257,0,0,1,4.5,33.038C128.11,228.142,124.276,240.964,116.842,242.742Z",
    transform: "translate(-74.364 -113.123)",
    fill: "#007adb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.656,172.086l25.416-6.079-2.158-4.117a5.45,5.45,0,0,0-6.1-2.771l-12.92,3.09a5.45,5.45,0,0,0-4.181,5.229Z",
    transform: "translate(-110.556 -138.361)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.907,315.546l25.416-6.079-.062,4.648a5.45,5.45,0,0,1-4.182,5.229l-12.92,3.09a5.45,5.45,0,0,1-6.095-2.77Z",
    transform: "translate(-128.31 -221.207)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1,197.6c7.988,33.4,23.81,58.246,35.344,55.488,2.735-.654,4.983-2.806,6.709-6.145,2.981-5.745,4.427-15.017,4.2-26.293a157.93,157.93,0,0,1-10.939-31.5,157.924,157.924,0,0,1-4.5-33.038c-4.9-10.161-10.393-17.773-15.647-21.549-3.054-2.2-6.031-3.094-8.762-2.44C62.984,134.883,60.116,164.2,68.1,197.6Z",
    transform: "translate(-60.971 -123.468)",
    fill: "#def2ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.534,197.142c6.094,25.479,16.745,45.978,26.576,53.045,2.981-5.745,4.427-15.017,4.2-26.293a157.929,157.929,0,0,1-10.939-31.5,157.923,157.923,0,0,1-4.5-33.038c-4.9-10.161-10.393-17.773-15.647-21.549C96.663,148.558,96.439,171.659,102.534,197.142Z",
    transform: "translate(-79.923 -126.712)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.234,192.2a2.873,2.873,0,1,0,2.126-3.462A2.873,2.873,0,0,0,79.234,192.2Z",
    transform: "translate(-69.544 -154.706)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.057,337.633a2.873,2.873,0,1,0,2.126-3.463A2.873,2.873,0,0,0,113.057,337.633Z",
    transform: "translate(-88.163 -234.763)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.965,241.22a2.873,2.873,0,1,0,2.126-3.463A2.873,2.873,0,0,0,84.965,241.22Z",
    transform: "translate(-72.699 -181.689)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.088,238.45c-6.713-10.54-12.546-25.279-16.427-41.5s-5.347-32.009-4.13-44.445c1.24-12.666,5.156-20.415,11.026-21.819,2.866-.685,5.994.171,9.3,2.545,5.344,3.841,10.827,11.379,15.854,21.8l.062.129,0,.143a157.79,157.79,0,0,0,4.479,32.9,157.778,157.778,0,0,0,10.891,31.364l.062.129,0,.143c.23,11.57-1.249,20.771-4.277,26.606-1.868,3.615-4.27,5.8-7.138,6.482C96.924,254.324,89.926,249.185,83.088,238.45Zm18.89-49.95a159.3,159.3,0,0,1-4.511-33.034c-4.847-10.012-10.305-17.529-15.377-21.174-2.981-2.142-5.749-2.928-8.228-2.335C68.654,133.2,65,140.738,63.835,152.63c-1.2,12.3.252,27.926,4.1,44.013s9.621,30.683,16.258,41.1c6.42,10.079,13.089,15.146,18.3,13.9,2.481-.593,4.594-2.548,6.28-5.81,2.873-5.538,4.34-14.71,4.133-25.836A159.341,159.341,0,0,1,101.979,188.5Z",
    transform: "translate(-60.164 -122.664)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.437,218.29,86.2,212.606a3.781,3.781,0,0,0,2.8-4.557h0a3.78,3.78,0,0,0-4.556-2.8l-23.765,5.684a3.781,3.781,0,0,0-2.8,4.556h0A3.781,3.781,0,0,0,62.437,218.29Z",
    transform: "translate(-57.776 -163.781)",
    fill: "#99d6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.156,288.011a2.873,2.873,0,1,0,2.126-3.462A2.874,2.874,0,0,0,96.156,288.011Z",
    transform: "translate(-78.86 -207.446)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.191 0.582)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 19.104)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.017,
    height: 70.119,
    rx: 11.97,
    transform: "translate(69.818 69.72) rotate(166.549)",
    fill: "#007adb"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55.017,
    height: 70.119,
    rx: 11.97,
    transform: "translate(76.191 68.196) rotate(166.549)",
    fill: "#ccedff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.595,
    height: 60.999,
    rx: 4.123,
    transform: "translate(70.548 64.856) rotate(166.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.386,
    cy: 4.524,
    rx: 3.386,
    ry: 4.524,
    transform: "translate(4.851 38.775) rotate(-13.451)",
    fill: "#005cb9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2.574,
    height: 9.047,
    transform: "translate(5.641 38.586) rotate(-13.451)",
    fill: "#5a8fbe"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.386,
    cy: 4.524,
    rx: 3.386,
    ry: 4.524,
    transform: "translate(2.348 39.374) rotate(-13.451)",
    fill: "#def2ff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M178.141,222.417l.027-.007a.655.655,0,0,0,.472-.563l1.291-12.68,4.184,4.589a.656.656,0,0,0,.636.2l8.948-2.14a.655.655,0,1,0-.3-1.273l-8.572,2.05-4.91-5.385a.655.655,0,0,0-1.135.374l-1.273,12.5-6.5-8.455a.655.655,0,0,0-1.131.166l-1.708,4.482-8.632,2.065a.654.654,0,1,0,.3,1.273l8.969-2.145a.655.655,0,0,0,.459-.4l1.414-3.711,6.794,8.831A.654.654,0,0,0,178.141,222.417Z",
    transform: "translate(-137.704 -165.377)",
    fill: "#2e1546"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.331 32.659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.151,229.733l-40.4,9.03L147.921,196.1l40.4-9.029Z",
    transform: "translate(-147.921 -187.07)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.58 4.809)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.11,213.757l1.315-.294.288,1.388-1.315.294Z",
    transform: "translate(-158.11 -206.408)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.036,213.1l1.314-.295.289,1.388-1.315.294Z",
    transform: "translate(-159.721 -206.047)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.96,212.448l1.316-.293.287,1.389-1.315.293Z",
    transform: "translate(-161.33 -205.688)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.888,211.794l1.315-.3.29,1.389-1.317.295Z",
    transform: "translate(-162.942 -205.326)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.813,211.139l1.317-.293.286,1.389-1.314.293Z",
    transform: "translate(-164.552 -204.967)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.743,210.487l1.313-.293.288,1.388-1.315.294Z",
    transform: "translate(-166.166 -204.608)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.664,209.833l1.315-.294.288,1.388-1.315.294Z",
    transform: "translate(-167.774 -204.247)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.514,208.525l1.316-.294.288,1.388-1.316.294Z",
    transform: "translate(-170.994 -203.528)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.37,207.218l1.315-.294.287,1.388-1.315.3Z",
    transform: "translate(-174.217 -202.808)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.295,206.563l1.315-.295.288,1.388-1.317.294Z",
    transform: "translate(-175.827 -202.447)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.071,204.6l1.318-.294.287,1.389-1.315.294Z",
    transform: "translate(-180.658 -201.367)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.778,201.984l1.316-.294.286,1.388-1.315.3Z",
    transform: "translate(-187.103 -199.927)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.706,201.332l1.313-.293.288,1.389-1.315.292Z",
    transform: "translate(-188.715 -199.568)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.628,200.678l1.315-.294.288,1.388-1.316.3Z",
    transform: "translate(-190.323 -199.208)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.554,200.024l1.315-.294.288,1.389-1.315.293Z",
    transform: "translate(-191.934 -198.848)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.48,199.369l1.316-.3.287,1.389-1.315.294Z",
    transform: "translate(-193.545 -198.487)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.408,198.715l1.314-.293.288,1.389-1.316.293Z",
    transform: "translate(-195.157 -198.128)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.332,198.062l1.316-.294.286,1.388-1.314.3Z",
    transform: "translate(-196.766 -197.768)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.752,216.845l1.315-.294.285,1.39-1.315.293Z",
    transform: "translate(-158.463 -208.108)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.306,212.921l1.315-.294.287,1.39-1.313.294Z",
    transform: "translate(-168.126 -205.947)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.155,211.613l1.316-.294.287,1.39-1.316.294Z",
    transform: "translate(-171.347 -205.227)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.084,210.96l1.315-.293.288,1.389-1.316.294Z",
    transform: "translate(-172.959 -204.869)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.009,210.306l1.315-.3.287,1.389-1.314.295Z",
    transform: "translate(-174.569 -204.508)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.787,208.344l1.316-.294.287,1.39-1.316.294Z",
    transform: "translate(-179.401 -203.428)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.715,207.69l1.315-.294.287,1.39L200,209.08Z",
    transform: "translate(-181.013 -203.068)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.417,205.073l1.315-.3.287,1.391-1.314.294Z",
    transform: "translate(-187.454 -201.627)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.973,201.15l1.314-.3.288,1.391-1.314.293Z",
    transform: "translate(-197.119 -199.467)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.388,219.936l1.315-.293.29,1.388-1.315.294Z",
    transform: "translate(-158.813 -209.81)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.241,218.63l1.315-.293.288,1.388-1.316.294Z",
    transform: "translate(-162.036 -209.09)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.166,217.975l1.318-.295.286,1.388-1.315.294Z",
    transform: "translate(-163.646 -208.729)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.1,217.321l1.314-.294.288,1.388-1.316.294Z",
    transform: "translate(-165.259 -208.369)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.947,216.012l1.313-.294.288,1.389-1.315.294Z",
    transform: "translate(-168.48 -207.649)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.794,214.705l1.316-.294.289,1.389-1.317.294Z",
    transform: "translate(-171.698 -206.93)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.723,214.052l1.316-.294.287,1.388-1.313.294Z",
    transform: "translate(-173.311 -206.57)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.573,212.742l1.318-.294.286,1.388-1.316.293Z",
    transform: "translate(-176.531 -205.849)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.5,212.09l1.314-.293.289,1.388-1.316.293Z",
    transform: "translate(-178.144 -205.491)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.426,211.436l1.316-.294.287,1.389-1.314.294Z",
    transform: "translate(-179.753 -205.13)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.353,210.782l1.315-.294.287,1.388-1.315.295Z",
    transform: "translate(-181.364 -204.77)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.279,210.128l1.315-.294.289,1.388-1.316.293Z",
    transform: "translate(-182.975 -204.41)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.2,209.473l1.314-.295.29,1.388-1.315.295Z",
    transform: "translate(-184.585 -204.049)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.058,208.166l1.314-.294.289,1.388-1.318.3Z",
    transform: "translate(-187.808 -203.33)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.908,206.858l1.314-.3.288,1.388-1.314.295Z",
    transform: "translate(-191.028 -202.609)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.831,206.2l1.316-.293.288,1.388-1.316.294Z",
    transform: "translate(-192.637 -202.25)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.76,205.549l1.316-.3.287,1.389-1.315.294Z",
    transform: "translate(-194.249 -201.889)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.612,204.242l1.314-.293.288,1.388-1.315.293Z",
    transform: "translate(-197.471 -201.171)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.032,223.025l1.315-.294.287,1.39-1.316.293Z",
    transform: "translate(-159.168 -211.51)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.879,221.718l1.316-.294.287,1.389-1.315.294Z",
    transform: "translate(-162.387 -210.79)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.808,221.064l1.315-.295.288,1.389-1.317.294Z",
    transform: "translate(-163.999 -210.43)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.734,220.409l1.316-.294.288,1.389-1.316.294Z",
    transform: "translate(-165.61 -210.07)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.583,219.1l1.315-.294.288,1.389-1.318.294Z",
    transform: "translate(-168.83 -209.35)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.212,215.831l1.316-.293.288,1.389-1.315.294Z",
    transform: "translate(-176.883 -207.55)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.14,215.179l1.316-.293.287,1.389-1.316.293Z",
    transform: "translate(-178.495 -207.191)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.069,214.525l1.314-.294.287,1.389-1.314.294Z",
    transform: "translate(-180.107 -206.831)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.694,211.254l1.318-.3.286,1.389-1.314.3Z",
    transform: "translate(-188.158 -205.029)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.549,209.946l1.314-.294.287,1.389-1.314.295Z",
    transform: "translate(-191.381 -204.31)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.472,209.292l1.316-.294.286,1.39-1.315.293Z",
    transform: "translate(-192.99 -203.95)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.4,208.639l1.315-.294.287,1.389-1.316.294Z",
    transform: "translate(-194.602 -203.59)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.251,207.331l1.315-.293.287,1.389-1.315.294Z",
    transform: "translate(-197.823 -202.871)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.668,226.116l1.316-.293.287,1.388-1.315.294Z",
    transform: "translate(-159.518 -213.212)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.519,224.808l1.315-.294.288,1.388-1.314.294Z",
    transform: "translate(-162.739 -212.492)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.445,224.154l1.317-.294.287,1.388-1.316.294Z",
    transform: "translate(-164.35 -212.131)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.375,223.5l1.316-.294.286,1.388-1.315.294Z",
    transform: "translate(-165.963 -211.771)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.219,222.192l1.318-.294.287,1.388-1.316.3Z",
    transform: "translate(-169.18 -211.051)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.076,220.884l1.316-.295.288,1.389-1.316.294Z",
    transform: "translate(-172.404 -210.331)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187,220.23l1.314-.294.288,1.389-1.314.294Z",
    transform: "translate(-174.015 -209.971)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.927,219.576l1.316-.294.286,1.389-1.314.294Z",
    transform: "translate(-175.625 -209.611)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.855,218.922l1.315-.294.288,1.389-1.317.294Z",
    transform: "translate(-177.237 -209.251)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.707,217.616l1.314-.295.289,1.388-1.316.3Z",
    transform: "translate(-180.458 -208.531)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.631,216.96l1.316-.294.287,1.388-1.314.294Z",
    transform: "translate(-182.068 -208.171)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.483,215.652l1.316-.294.287,1.389-1.315.3Z",
    transform: "translate(-185.289 -207.451)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.339,214.344l1.314-.3.287,1.389-1.314.3Z",
    transform: "translate(-188.513 -206.73)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.189,213.037l1.314-.295.288,1.389-1.315.294Z",
    transform: "translate(-191.733 -206.011)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.111,212.383l1.315-.293.289,1.388-1.317.294Z",
    transform: "translate(-193.342 -205.652)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.038,211.73l1.316-.294.288,1.389-1.315.294Z",
    transform: "translate(-194.953 -205.292)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.89,210.422l1.315-.294.288,1.388-1.315.293Z",
    transform: "translate(-198.174 -204.572)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.309,229.2l1.315-.294.287,1.389-1.316.295Z",
    transform: "translate(-159.871 -214.911)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.862,225.281l1.316-.3.288,1.39-1.315.294Z",
    transform: "translate(-169.534 -212.751)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.491,222.012l1.317-.294.286,1.388-1.315.3Z",
    transform: "translate(-177.587 -210.952)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.422,221.359l1.315-.294.288,1.389-1.317.294Z",
    transform: "translate(-179.2 -210.592)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.346,220.7l1.316-.3.287,1.39-1.314.294Z",
    transform: "translate(-180.81 -210.231)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.977,217.434l1.314-.3.29,1.389-1.316.3Z",
    transform: "translate(-188.864 -208.431)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.531,213.511l1.315-.293.287,1.389-1.315.294Z",
    transform: "translate(-198.527 -206.272)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.947,232.3l1.316-.295.289,1.389-1.317.293Z",
    transform: "translate(-160.222 -216.613)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.874,231.642l1.314-.293.289,1.388-1.314.294Z",
    transform: "translate(-161.834 -216.254)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.8,230.988l1.316-.295.288,1.389-1.315.294Z",
    transform: "translate(-163.443 -215.893)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.726,230.334l1.316-.293.287,1.388-1.315.293Z",
    transform: "translate(-165.055 -215.534)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.653,229.68l1.314-.295.289,1.388-1.316.3Z",
    transform: "translate(-166.666 -215.173)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.576,229.026l1.316-.293.287,1.388-1.314.293Z",
    transform: "translate(-168.276 -214.814)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.5,228.372l1.315-.295.287,1.389-1.316.294Z",
    transform: "translate(-169.888 -214.453)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.355,227.065l1.317-.295.287,1.388-1.317.294Z",
    transform: "translate(-173.108 -213.733)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.209,225.757l1.314-.293.287,1.388-1.316.293Z",
    transform: "translate(-176.331 -213.014)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.058,224.448l1.317-.294.287,1.388-1.315.3Z",
    transform: "translate(-179.55 -212.293)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.911,223.139l1.315-.295.289,1.388-1.315.294Z",
    transform: "translate(-182.772 -211.572)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.763,221.832l1.314-.294.288,1.389-1.314.294Z",
    transform: "translate(-185.994 -210.853)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.617,220.523l1.316-.3.287,1.39-1.316.293Z",
    transform: "translate(-189.216 -210.132)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.544,219.869l1.313-.293.288,1.388-1.315.3Z",
    transform: "translate(-190.828 -209.773)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.466,219.216l1.316-.294.287,1.389-1.315.293Z",
    transform: "translate(-192.436 -209.413)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.394,218.562l1.314-.294.288,1.389-1.315.294Z",
    transform: "translate(-194.048 -209.053)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.318,217.909l1.315-.293.289,1.388-1.317.294Z",
    transform: "translate(-195.657 -208.694)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.244,217.255l1.316-.3.287,1.388-1.313.294Z",
    transform: "translate(-197.268 -208.333)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.171,216.6l1.315-.294.288,1.389-1.316.293Z",
    transform: "translate(-198.88 -207.973)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.7,227.537l1.315-.3.288,1.39-1.315.294Z",
    transform: "translate(-179.903 -213.993)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.625,226.882l1.316-.293.287,1.39-1.315.294Z",
    transform: "translate(-181.514 -213.633)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.406,224.921l1.314-.294.288,1.39-1.316.294Z",
    transform: "translate(-186.348 -212.554)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.225,238.476l1.319-.295.286,1.389-1.315.3Z",
    transform: "translate(-160.926 -220.015)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,236.514l1.316-.293.289,1.389-1.316.293Z",
    transform: "translate(-165.759 -218.935)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.932,235.86l1.316-.295.287,1.389-1.314.3Z",
    transform: "translate(-167.37 -218.575)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.859,235.206l1.315-.293.288,1.388-1.315.293Z",
    transform: "translate(-168.982 -218.216)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.784,234.552l1.314-.3.288,1.389-1.315.294Z",
    transform: "translate(-170.592 -217.854)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.708,233.9l1.316-.293.288,1.389-1.316.293Z",
    transform: "translate(-172.201 -217.495)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.635,233.244l1.316-.294.288,1.389-1.315.294Z",
    transform: "translate(-173.813 -217.135)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.488,231.937l1.315-.294.287,1.389-1.314.294Z",
    transform: "translate(-177.035 -216.415)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.115,228.667l1.316-.294.287,1.389-1.316.294Z",
    transform: "translate(-185.087 -214.616)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.042,228.013l1.316-.294.286,1.388-1.315.294Z",
    transform: "translate(-186.698 -214.256)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.97,227.36l1.315-.294.289,1.388-1.318.294Z",
    transform: "translate(-188.31 -213.896)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.748,225.4l1.314-.294.287,1.389-1.314.294Z",
    transform: "translate(-193.142 -212.815)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.6,224.09l1.316-.294.287,1.388-1.317.295Z",
    transform: "translate(-196.362 -212.096)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.526,223.436l1.314-.294.287,1.389-1.313.293Z",
    transform: "translate(-197.974 -211.736)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.449,222.781l1.316-.294.287,1.389-1.316.294Z",
    transform: "translate(-199.583 -211.375)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.793,240.911l1.316-.294.286,1.389-1.314.293Z",
    transform: "translate(-162.89 -221.356)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.722,240.256l1.314-.295.288,1.39-1.317.294Z",
    transform: "translate(-164.502 -220.995)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.574,238.949l1.314-.3.288,1.39-1.314.294Z",
    transform: "translate(-167.724 -220.275)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.5,238.3l1.315-.293.287,1.389-1.315.294Z",
    transform: "translate(-169.333 -219.916)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.349,236.988l1.316-.293.286,1.39-1.314.293Z",
    transform: "translate(-172.554 -219.196)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.981,233.718l1.313-.294.289,1.39-1.315.293Z",
    transform: "translate(-180.609 -217.395)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.9,233.064l1.318-.293.287,1.388-1.315.295Z",
    transform: "translate(-182.217 -217.036)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.833,232.411l1.313-.294.289,1.388-1.316.294Z",
    transform: "translate(-183.83 -216.676)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.754,231.757l1.316-.294.288,1.388-1.315.294Z",
    transform: "translate(-185.438 -216.316)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.606,230.448l1.318-.294.286,1.388-1.315.295Z",
    transform: "translate(-188.66 -215.596)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.461,229.139l1.315-.293.287,1.389-1.314.294Z",
    transform: "translate(-191.883 -214.876)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.387,228.486l1.314-.294.288,1.39-1.315.293Z",
    transform: "translate(-193.493 -214.516)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.31,227.832l1.315-.294.287,1.389-1.314.295Z",
    transform: "translate(-195.103 -214.156)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.237,227.177l1.317-.295.286,1.39-1.316.294Z",
    transform: "translate(-196.714 -213.795)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.165,226.524l1.313-.293.288,1.389-1.315.294Z",
    transform: "translate(-198.326 -213.436)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.358,243.347l1.317-.294.287,1.389-1.316.294Z",
    transform: "translate(-164.852 -222.697)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.138,241.386l1.315-.294.287,1.389-1.314.294Z",
    transform: "translate(-169.686 -221.617)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.063,240.731l1.315-.294.288,1.389-1.315.294Z",
    transform: "translate(-171.296 -221.256)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.911,239.424l1.317-.295.288,1.389-1.317.294Z",
    transform: "translate(-174.515 -220.537)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.767,238.116l1.314-.294.288,1.389-1.316.294Z",
    transform: "translate(-177.739 -219.817)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.691,237.462l1.316-.294.287,1.39-1.315.294Z",
    transform: "translate(-179.348 -219.457)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.619,236.808l1.315-.293.289,1.389-1.317.294Z",
    transform: "translate(-180.96 -219.097)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.544,236.154l1.315-.294.286,1.389-1.312.294Z",
    transform: "translate(-182.57 -218.737)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.4,234.845l1.315-.294.287,1.389-1.314.295Z",
    transform: "translate(-185.793 -218.017)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.323,234.191l1.315-.294.288,1.389-1.316.294Z",
    transform: "translate(-187.403 -217.657)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.174,232.884l1.316-.293.287,1.39-1.315.293Z",
    transform: "translate(-190.624 -216.937)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.1,232.23l1.314-.294.286,1.39-1.314.295Z",
    transform: "translate(-192.236 -216.577)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.952,230.922l1.314-.295.288,1.389-1.314.3Z",
    transform: "translate(-195.456 -215.857)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.728,228.96l1.316-.295.287,1.39-1.315.294Z",
    transform: "translate(-200.287 -214.777)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.077,247.091l1.313-.294.289,1.39-1.316.294Z",
    transform: "translate(-163.597 -224.758)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,246.437l1.316-.294.287,1.389-1.315.3Z",
    transform: "translate(-165.204 -224.398)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.778,244.475l1.314-.294.288,1.39-1.316.293Z",
    transform: "translate(-170.038 -223.318)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.483,241.86l1.313-.294.288,1.389-1.314.294Z",
    transform: "translate(-176.481 -221.878)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.4,241.206l1.316-.294.287,1.39-1.315.293Z",
    transform: "translate(-178.09 -221.518)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.332,240.552l1.315-.294.289,1.389-1.318.295Z",
    transform: "translate(-179.701 -221.158)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.74,235.322l1.314-.294.29,1.389-1.314.295Z",
    transform: "translate(-192.587 -218.279)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.593,234.012l1.314-.3.288,1.39-1.315.293Z",
    transform: "translate(-195.809 -217.557)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.515,233.359l1.317-.293.287,1.388-1.316.3Z",
    transform: "translate(-197.418 -217.199)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.446,232.706l1.314-.294.287,1.388-1.314.293Z",
    transform: "translate(-199.031 -216.839)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.369,232.052l1.315-.294.287,1.388-1.315.295Z",
    transform: "translate(-200.64 -216.478)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.784,250.836l1.316-.293.288,1.389-1.316.294Z",
    transform: "translate(-162.334 -226.82)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.564,248.874l1.317-.293.288,1.389-1.318.294Z",
    transform: "translate(-167.168 -225.74)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.416,247.566l1.316-.293.288,1.388-1.316.294Z",
    transform: "translate(-170.389 -225.02)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.343,246.912l1.314-.295.287,1.389-1.313.294Z",
    transform: "translate(-172 -224.659)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.267,246.258l1.315-.293.288,1.389-1.316.293Z",
    transform: "translate(-173.61 -224.3)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.191,245.606l1.317-.294.286,1.388-1.315.3Z",
    transform: "translate(-175.22 -223.94)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.045,244.3,196.36,244l.288,1.388-1.315.293Z",
    transform: "translate(-178.442 -223.22)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.675,241.026l1.314-.294.288,1.389-1.315.294Z",
    transform: "translate(-186.496 -221.419)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.6,240.372l1.317-.294.287,1.389-1.316.294Z",
    transform: "translate(-188.105 -221.059)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.454,239.066l1.316-.293.286,1.388-1.316.294Z",
    transform: "translate(-191.328 -220.34)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.008,235.141l1.315-.294.286,1.389-1.313.294Z",
    transform: "translate(-200.992 -218.179)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.282,252.618l1.313-.294.288,1.389-1.314.294Z",
    transform: "translate(-165.912 -227.8)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.134,251.31l1.314-.294.288,1.389-1.315.3Z",
    transform: "translate(-169.133 -227.08)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.057,250.656l1.316-.294.286,1.388-1.314.294Z",
    transform: "translate(-170.742 -226.72)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.833,248.694l1.315-.3.288,1.389-1.316.294Z",
    transform: "translate(-175.573 -225.639)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.537,246.077l1.316-.294.287,1.389-1.314.294Z",
    transform: "translate(-182.016 -224.199)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.465,245.423l1.316-.294.286,1.39-1.315.293Z",
    transform: "translate(-183.628 -223.839)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.392,244.769l1.314-.294.288,1.389-1.317.294Z",
    transform: "translate(-185.239 -223.48)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.315,244.116l1.315-.294.287,1.389-1.313.294Z",
    transform: "translate(-186.848 -223.12)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.24,243.461l1.316-.294.287,1.39-1.316.294Z",
    transform: "translate(-188.458 -222.759)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.168,242.808l1.314-.293.288,1.39-1.315.293Z",
    transform: "translate(-190.07 -222.4)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.946,240.845l1.314-.294.288,1.39-1.316.293Z",
    transform: "translate(-194.902 -221.319)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.725,238.884l1.315-.294.287,1.388-1.315.294Z",
    transform: "translate(-199.735 -220.24)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.7,253.745l1.314-.294.288,1.389-1.314.294Z",
    transform: "translate(-171.094 -228.42)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.621,253.091l1.315-.293.289,1.39-1.317.293Z",
    transform: "translate(-172.704 -228.061)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4,251.129l1.315-.294.287,1.389-1.314.294Z",
    transform: "translate(-177.536 -226.98)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.325,250.475l1.317-.293.284,1.39-1.314.293Z",
    transform: "translate(-179.147 -226.621)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.957,247.206l1.313-.294.289,1.39-1.316.293Z",
    transform: "translate(-187.202 -224.821)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.879,246.553l1.316-.294.288,1.388-1.314.3Z",
    transform: "translate(-188.81 -224.461)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.807,245.9l1.315-.293.288,1.388-1.315.293Z",
    transform: "translate(-190.422 -224.102)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.732,245.245l1.315-.3.289,1.389-1.316.294Z",
    transform: "translate(-192.032 -223.741)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.584,243.937l1.316-.293.288,1.388-1.315.294Z",
    transform: "translate(-195.253 -223.022)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.511,243.284l1.316-.293.288,1.388-1.317.293Z",
    transform: "translate(-196.865 -222.662)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.438,242.629l1.314-.3.288,1.389-1.314.295Z",
    transform: "translate(-198.476 -222.301)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.362,241.974l1.315-.295.288,1.39-1.315.293Z",
    transform: "translate(-200.086 -221.94)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.287,241.32l1.316-.293.287,1.388-1.315.295Z",
    transform: "translate(-201.696 -221.581)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.631,259.452l1.315-.293.288,1.39-1.315.292Z",
    transform: "translate(-165.003 -231.562)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.558,258.8l1.315-.294.289,1.388-1.316.3Z",
    transform: "translate(-166.614 -231.202)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.482,258.144l1.316-.294.288,1.39-1.315.293Z",
    transform: "translate(-168.224 -230.842)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.41,257.489l1.316-.294.287,1.389-1.316.295Z",
    transform: "translate(-169.835 -230.482)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.964,253.566l1.314-.293.288,1.388-1.315.294Z",
    transform: "translate(-179.499 -228.323)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.819,252.258l1.315-.3.287,1.39-1.317.294Z",
    transform: "translate(-182.721 -227.602)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.6,250.3l1.316-.293.288,1.388-1.315.294Z",
    transform: "translate(-187.553 -226.523)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.523,249.642l1.314-.3.287,1.39-1.314.294Z",
    transform: "translate(-189.165 -226.161)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.447,248.988l1.315-.293.287,1.389-1.315.294Z",
    transform: "translate(-190.774 -225.802)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.3,247.68l1.314-.294.287,1.39-1.315.293Z",
    transform: "translate(-193.997 -225.082)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.151,246.372l1.317-.293.285,1.389-1.314.293Z",
    transform: "translate(-197.217 -224.362)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.08,245.718l1.314-.295.286,1.39-1.315.294Z",
    transform: "translate(-198.829 -224.001)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.928,244.41l1.315-.295.287,1.389-1.313.3Z",
    transform: "translate(-202.049 -223.281)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.272,262.542l1.315-.292.288,1.388-1.316.293Z",
    transform: "translate(-165.356 -233.264)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.125,261.234l1.315-.293.287,1.388-1.315.293Z",
    transform: "translate(-168.578 -232.544)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.9,259.272l1.315-.293.288,1.388-1.315.293Z",
    transform: "translate(-173.409 -231.464)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.6,256.656l1.315-.294.288,1.389-1.315.293Z",
    transform: "translate(-179.85 -230.023)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.529,256l1.315-.293.289,1.389-1.316.294Z",
    transform: "translate(-181.461 -229.664)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.454,255.349l1.317-.294.287,1.388-1.315.295Z",
    transform: "translate(-183.071 -229.303)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.383,254.7l1.314-.293.287,1.388-1.314.293Z",
    transform: "translate(-184.684 -228.944)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.237,253.386l1.315-.294.287,1.388-1.314.295Z",
    transform: "translate(-187.906 -228.223)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.163,252.732l1.314-.294.287,1.388-1.314.294Z",
    transform: "translate(-189.517 -227.863)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.086,252.079l1.315-.294.286,1.389-1.314.293Z",
    transform: "translate(-191.126 -227.503)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.012,251.424l1.315-.294.287,1.389-1.316.294Z",
    transform: "translate(-192.736 -227.143)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.938,250.771l1.315-.293.289,1.388-1.318.294Z",
    transform: "translate(-194.347 -226.784)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.864,250.117l1.315-.294.288,1.389-1.313.294Z",
    transform: "translate(-195.958 -226.423)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.714,248.809l1.315-.295.288,1.389L233,250.2Z",
    transform: "translate(-199.178 -225.703)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.64,248.156l1.318-.293.286,1.388-1.315.294Z",
    transform: "translate(-200.789 -225.344)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.389,261.054l1.318-.293.287,1.39-1.316.294Z",
    transform: "translate(-176.98 -232.444)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.322,260.4l1.314-.295.288,1.39-1.315.294Z",
    transform: "translate(-178.595 -232.084)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.245,259.746l1.315-.293.288,1.389-1.315.294Z",
    transform: "translate(-180.204 -231.724)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.17,259.093l1.316-.294.287,1.39-1.314.293Z",
    transform: "translate(-181.814 -231.364)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.022,257.783l1.314-.293.288,1.391-1.315.293Z",
    transform: "translate(-185.036 -230.644)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.878,256.475l1.314-.294.287,1.39-1.317.294Z",
    transform: "translate(-188.259 -229.923)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.8,255.821l1.314-.294.289,1.391-1.316.294Z",
    transform: "translate(-189.869 -229.563)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.508,253.205l1.314-.294.287,1.39-1.314.294Z",
    transform: "translate(-196.312 -228.124)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.358,251.9l1.314-.293.287,1.39-1.315.294Z",
    transform: "translate(-199.533 -227.404)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.281,251.244l1.315-.294.288,1.39-1.315.294Z",
    transform: "translate(-201.142 -227.044)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.622,269.376l1.318-.3.288,1.39-1.318.294Z",
    transform: "translate(-164.447 -237.025)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.554,268.722l1.314-.294.289,1.389-1.315.295Z",
    transform: "translate(-166.061 -236.665)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.476,268.069l1.315-.293.287,1.389-1.313.294Z",
    transform: "translate(-167.67 -236.306)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.4,267.415l1.315-.295.289,1.39-1.317.294Z",
    transform: "translate(-169.281 -235.945)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.329,266.762l1.315-.293.288,1.389-1.315.294Z",
    transform: "translate(-170.892 -235.587)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.255,266.107l1.315-.3.287,1.389-1.314.3Z",
    transform: "translate(-172.502 -235.225)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.181,265.453l1.316-.293.287,1.389-1.316.293Z",
    transform: "translate(-174.113 -234.866)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.031,264.147l1.316-.294.287,1.389-1.314.294Z",
    transform: "translate(-177.333 -234.146)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.885,262.838l1.315-.295.286,1.388-1.315.295Z",
    transform: "translate(-180.556 -233.426)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.735,261.53l1.315-.3.288,1.388-1.315.294Z",
    transform: "translate(-183.776 -232.706)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.44,258.914l1.316-.294.287,1.388-1.315.293Z",
    transform: "translate(-190.22 -231.266)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.289,257.607l1.317-.293.288,1.388L222.58,259Z",
    transform: "translate(-193.44 -230.547)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.144,256.3l1.314-.294.288,1.389-1.315.294Z",
    transform: "translate(-196.663 -229.826)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.846,253.683l1.315-.294.289,1.388-1.316.295Z",
    transform: "translate(-203.104 -228.386)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.263,272.467l1.318-.294.287,1.388-1.315.3Z",
    transform: "translate(-164.8 -238.727)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.82,268.543l1.316-.293.286,1.389-1.315.293Z",
    transform: "translate(-174.465 -236.567)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.675,267.236l1.314-.294.288,1.388-1.316.294Z",
    transform: "translate(-177.688 -235.847)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.448,265.273l1.316-.293.288,1.389-1.318.293Z",
    transform: "translate(-182.517 -234.767)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.3,263.965l1.315-.293.286,1.389-1.315.293Z",
    transform: "translate(-185.74 -234.047)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.157,262.656l1.314-.3.288,1.39-1.315.294Z",
    transform: "translate(-188.963 -233.325)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.08,262l1.315-.293.288,1.388-1.315.295Z",
    transform: "translate(-190.572 -232.966)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.784,259.388l1.315-.295.287,1.389-1.315.294Z",
    transform: "translate(-197.015 -231.526)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.487,256.771l1.316-.295.288,1.389-1.316.295Z",
    transform: "translate(-203.458 -230.086)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.907,275.556l1.315-.3.288,1.389-1.316.293Z",
    transform: "translate(-165.154 -240.427)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.756,274.248l1.316-.294.287,1.389-1.314.292Z",
    transform: "translate(-168.375 -239.707)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.683,273.594,181,273.3l.286,1.389-1.315.3Z",
    transform: "translate(-169.986 -239.347)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.61,272.94l1.314-.293.288,1.388-1.315.294Z",
    transform: "translate(-171.597 -238.988)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.459,271.633l1.315-.293.29,1.388-1.317.293Z",
    transform: "translate(-174.817 -238.268)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.311,270.324l1.316-.294.286,1.388-1.314.294Z",
    transform: "translate(-178.038 -237.547)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.163,269.015l1.314-.294.289,1.388-1.316.295Z",
    transform: "translate(-181.26 -236.826)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.087,268.362l1.318-.293.286,1.388-1.315.293Z",
    transform: "translate(-182.869 -236.468)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.018,267.708l1.313-.3.289,1.389-1.316.295Z",
    transform: "translate(-184.482 -236.106)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.864,266.4l1.317-.295.287,1.389-1.316.295Z",
    transform: "translate(-187.701 -235.387)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.794,265.746l1.315-.294.288,1.389-1.316.293Z",
    transform: "translate(-189.314 -235.027)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.72,265.092l1.315-.294.288,1.39-1.315.294Z",
    transform: "translate(-190.924 -234.666)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.646,264.438l1.315-.293.287,1.389-1.314.294Z",
    transform: "translate(-192.535 -234.307)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.572,263.784l1.316-.294.286,1.389-1.315.294Z",
    transform: "translate(-194.146 -233.947)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.5,263.131l1.314-.294.288,1.389-1.315.293Z",
    transform: "translate(-195.757 -233.587)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.422,262.477l1.315-.294.288,1.388-1.316.3Z",
    transform: "translate(-197.366 -233.228)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.543,278.644l1.316-.293.287,1.39-1.318.293Z",
    transform: "translate(-165.505 -242.127)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.4,277.338l1.314-.292.288,1.389-1.314.293Z",
    transform: "translate(-168.728 -241.409)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.322,276.684l1.315-.3.288,1.39-1.315.295Z",
    transform: "translate(-170.337 -241.047)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.248,276.029l1.315-.294.288,1.389-1.315.294Z",
    transform: "translate(-171.948 -240.687)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.1,274.72l1.317-.293.287,1.39-1.316.294Z",
    transform: "translate(-175.169 -239.967)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.952,273.412l1.314-.294.288,1.39-1.316.294Z",
    transform: "translate(-178.391 -239.247)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.876,272.759l1.316-.293.287,1.39-1.314.294Z",
    transform: "translate(-180 -238.888)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.8,272.1l1.316-.295.288,1.391-1.317.293Z",
    transform: "translate(-181.611 -238.527)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.654,270.8l1.316-.294.287,1.39-1.314.293Z",
    transform: "translate(-184.833 -237.807)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.583,270.144l1.314-.294.287,1.389-1.314.294Z",
    transform: "translate(-186.445 -237.448)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.505,269.489l1.316-.294.287,1.39-1.316.294Z",
    transform: "translate(-188.054 -237.087)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.211,266.874l1.315-.294.287,1.389-1.315.294Z",
    transform: "translate(-194.497 -235.648)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.84,263.6l1.316-.294.287,1.389-1.315.295Z",
    transform: "translate(-202.551 -233.847)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.768,262.95l1.313-.294.288,1.39-1.315.293Z",
    transform: "translate(-204.162 -233.488)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.179,281.737l1.318-.293.287,1.388-1.315.294Z",
    transform: "translate(-165.855 -243.83)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.039,280.429l1.314-.293.287,1.389-1.315.294Z",
    transform: "translate(-169.081 -243.11)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.963,279.775l1.315-.295.287,1.389-1.315.294Z",
    transform: "translate(-170.69 -242.749)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.889,279.12l1.315-.294.287,1.389-1.315.294Z",
    transform: "translate(-172.301 -242.389)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.739,277.813l1.316-.294.285,1.389-1.314.295Z",
    transform: "translate(-175.521 -241.67)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.37,274.543l1.316-.294.287,1.389-1.315.293Z",
    transform: "translate(-183.576 -239.869)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.927,270.62l1.314-.294.286,1.388-1.314.294Z",
    transform: "translate(-193.241 -237.71)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.7,268.657l1.315-.293.289,1.388-1.315.294Z",
    transform: "translate(-198.071 -236.63)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.627,268l1.315-.295.29,1.39-1.315.293Z",
    transform: "translate(-199.681 -236.269)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.552,267.349l1.316-.294.287,1.389-1.314.294Z",
    transform: "translate(-201.291 -235.909)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.48,266.694l1.315-.295.288,1.39-1.315.293Z",
    transform: "translate(-202.903 -235.549)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.4,266.041l1.315-.293.287,1.389-1.314.294Z",
    transform: "translate(-204.513 -235.19)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.825,284.826l1.315-.294.287,1.389-1.315.294Z",
    transform: "translate(-166.21 -245.53)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.379,280.9l1.314-.295.289,1.389-1.316.294Z",
    transform: "translate(-175.874 -243.37)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.159,278.941l1.313-.293.289,1.389-1.315.293Z",
    transform: "translate(-180.707 -242.291)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.08,278.286l1.318-.3.287,1.39-1.315.294Z",
    transform: "translate(-182.315 -241.929)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.785,275.671l1.316-.294.288,1.389-1.317.295Z",
    transform: "translate(-188.758 -240.49)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.417,272.4l1.316-.294.288,1.389-1.316.294Z",
    transform: "translate(-196.813 -238.69)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.345,271.746l1.315-.294.288,1.389-1.315.294Z",
    transform: "translate(-198.425 -238.33)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.2,270.439l1.314-.294.287,1.389-1.314.294Z",
    transform: "translate(-201.645 -237.61)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.119,269.786l1.315-.293.287,1.388-1.315.294Z",
    transform: "translate(-203.255 -237.251)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.045,269.132l1.314-.294.289,1.389-1.316.294Z",
    transform: "translate(-204.866 -236.891)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.463,287.916l1.315-.294.288,1.389-1.316.294Z",
    transform: "translate(-166.562 -247.231)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.388,287.262l1.317-.294.287,1.389-1.315.294Z",
    transform: "translate(-168.172 -246.871)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.317,286.607l1.313-.294.29,1.389L179.6,288Z",
    transform: "translate(-169.784 -246.51)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.238,285.953l1.318-.294.288,1.389-1.316.294Z",
    transform: "translate(-171.392 -246.151)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.169,285.3l1.316-.295.287,1.39-1.314.293Z",
    transform: "translate(-173.006 -245.79)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.1,284.646l1.313-.293.289,1.389-1.315.294Z",
    transform: "translate(-174.617 -245.432)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.016,283.992l1.316-.294.288,1.389-1.316.295Z",
    transform: "translate(-176.225 -245.071)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.869,282.684l1.316-.294.288,1.39-1.317.294Z",
    transform: "translate(-179.446 -244.351)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.723,281.377l1.315-.294.287,1.388-1.316.3Z",
    transform: "translate(-182.669 -243.631)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.577,280.068l1.313-.295.289,1.39-1.315.293Z",
    transform: "translate(-185.891 -242.91)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.423,278.761l1.317-.295.288,1.389-1.316.294Z",
    transform: "translate(-189.109 -242.191)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.28,277.454l1.314-.293.288,1.388-1.315.294Z",
    transform: "translate(-192.334 -241.472)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.2,276.8l1.315-.3.288,1.388-1.315.3Z",
    transform: "translate(-193.943 -241.111)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.909,274.182l1.315-.293.287,1.389-1.315.295Z",
    transform: "translate(-200.387 -239.671)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.684,272.221l1.316-.294.288,1.389-1.317.294Z",
    transform: "translate(-205.217 -238.591)",
    fill: "#66c8ff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M164.65,173.589,244.1,114.417l-45.77,55.524-32.88,7.349Z",
    transform: "translate(-140.8 -114.417)",
    fill: "url(#b)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.102 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M326.819,151.3c-2.642.264-7.394,2.614-11.3,4.77-4.5,2.483-8.825,5.257-8.566,4.645.317-.755,6.769-5.507,11.962-9.19a32.863,32.863,0,0,0,5.443-5.14c2.626-2.88,1.226-10.333-1.686-12.194s-5.123.246-9.064,2.979c-2.155,1.494-4.41,3.178-6.4,4.711,2.744-2.263,5.964-5.034,8.645-7.663,2.111-2.07,4.448-3.934,5.4-5.512,3.65-6.075-1.794-11.486-3.909-12.506s-5.393,1.791-9.76,5.929c-5.3,5.022-11,10.774-11.277,10.3-.511-.866,9.821-11.579,13.867-16.252,2.372-2.741,5.559-10.217,5.348-14.613-.176-3.649-.462-8.961-6.91-8.86s-6.633,10.372-11.242,14.95S259.38,140.3,259.38,140.3s-9.839,33.018-8.65,44.106a137.758,137.758,0,0,0,2.918,17.793L233.5,369.532l52.6-4.068,6.2-148.494c1.841-1.319,5.9-6.549,9.754-10.752S314,181.941,314.535,180.025c.21-.758,2.422-2.918,4.432-5.672,3.069-4.206,8.723-8.1,10.788-9.985C333.607,160.861,330.005,150.981,326.819,151.3Z",
    transform: "translate(-237.579 -73.613)",
    fill: "#ffc4a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.388,301.172c-10.018-12.946,43.454-26.3,60.741-15.908-.976,2.613-3.334,8.4-5.847,13.834a105.56,105.56,0,0,0-20.229,13.124C285.665,323.654,276.336,316.611,264.388,301.172Z",
    transform: "translate(-248.622 -177.569)",
    fill: "#f7aa8d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.652,188.975c-4.508,1.44-8.125.65-9.565-4.117L231.947,81.68c-2.162-5.107-1.409-11.749,4.343-13.178l45.339-14.467C286.137,52.6,292.2,57.226,293.636,62l31.142,103.179c1.438,4.768-2.279,7.9-6.788,9.336Z",
    transform: "translate(-230.834 -52.18)",
    fill: "#002776"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.783,185.562A8.662,8.662,0,0,1,271,179.524L239.856,76.345a8.995,8.995,0,0,1,5.565-11.257L290.76,50.621a8.66,8.66,0,0,1,10.785,6.04l31.143,103.178a9,9,0,0,1-5.567,11.257Z",
    transform: "translate(-235.576 -50.235)",
    fill: "#005cb9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.748,166.053a4.9,4.9,0,0,1-3.036,6.14l-45.338,14.467a4.717,4.717,0,0,1-5.883-3.294L248.349,80.187a4.9,4.9,0,0,1,3.036-6.14L296.723,59.58a4.718,4.718,0,0,1,5.883,3.294Z",
    transform: "translate(-240.353 -55.263)",
    fill: "#def2ff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.773 4.106)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M302.046,64.433,246.3,82.22l-3.795-12.578L298.25,51.855Z",
    transform: "translate(-245.032 -55.233)",
    fill: "#007adb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(33.816 87.193)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M361.394,257.368a4.9,4.9,0,0,1-3.037,6.141l-28.739,9.17a4.718,4.718,0,0,1-5.883-3.293l-.157-.525a4.9,4.9,0,0,1,3.034-6.139l28.74-9.171a4.718,4.718,0,0,1,5.883,3.294Z",
    transform: "translate(-323.354 -253.34)",
    fill: "#ff5490"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.957, -0.29, 0.29, 0.957, 11.591, 12.082)",
    fill: "#fff",
    fontSize: 3,
    fontFamily: "Montserrat-ExtraBold, Montserrat",
    fontWeight: 800,
    letterSpacing: "0.1em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "SCAN"))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.298 31.747)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.946 6.205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M335.943,176.315,305.2,186.126l-9.815-32.517,30.744-9.81Z",
    transform: "translate(-295.385 -143.798)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.773 3.937)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M303.779,169.93l1-.32.32,1.058-1,.32Z",
    transform: "translate(-303.779 -161.945)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.006,169.219l1-.32.32,1.058-1,.32Z",
    transform: "translate(-305.005 -161.553)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.231,168.509l1-.319.32,1.059-1,.318Z",
    transform: "translate(-306.23 -161.163)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.459,167.8l1-.32.321,1.059-1,.32Z",
    transform: "translate(-307.456 -160.771)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.686,167.086l1-.319.319,1.059-1,.319Z",
    transform: "translate(-308.682 -160.38)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.915,166.377l1-.319.32,1.058-1,.32Z",
    transform: "translate(-309.909 -159.989)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.139,165.667l1-.32.32,1.058-1,.32Z",
    transform: "translate(-311.133 -159.598)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.591,164.246l1-.319.32,1.058-1,.32Z",
    transform: "translate(-313.584 -158.816)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.047,162.825l1-.32.319,1.058-1,.32Z",
    transform: "translate(-316.037 -158.034)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.272,162.114l1-.32.32,1.058-1,.32Z",
    transform: "translate(-317.262 -157.642)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.952,159.981l1-.32.319,1.059-1,.319Z",
    transform: "translate(-320.939 -156.468)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.861,157.139l1-.319.318,1.058-1,.32Z",
    transform: "translate(-325.844 -154.904)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.09,156.43l1-.319.319,1.059-1,.318Z",
    transform: "translate(-327.071 -154.514)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.314,155.719l1-.32.32,1.058-1,.32Z",
    transform: "translate(-328.295 -154.122)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.541,155.009l1-.319.32,1.059-1,.319Z",
    transform: "translate(-329.521 -153.731)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.767,154.3l1-.32.319,1.059-1,.32Z",
    transform: "translate(-330.746 -153.339)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355,153.587l1-.318.321,1.059-1,.319Z",
    transform: "translate(-331.973 -152.949)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.22,152.877l1-.32.318,1.058-1,.32Z",
    transform: "translate(-333.198 -152.557)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.49,172.284l1-.32.318,1.06-1,.319Z",
    transform: "translate(-304.171 -163.24)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.851,168.021l1-.32.319,1.059-1,.319Z",
    transform: "translate(-311.526 -160.894)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.3,166.6l1-.32.319,1.059-1,.32Z",
    transform: "translate(-313.976 -160.111)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.531,165.89l1-.319.32,1.059-1,.319Z",
    transform: "translate(-315.203 -159.721)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.757,165.179l1-.32.319,1.059-1,.32Z",
    transform: "translate(-316.428 -159.329)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.438,163.047l1-.319.319,1.059-1,.32Z",
    transform: "translate(-320.106 -158.156)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.666,162.337l1-.319.319,1.059-1,.319Z",
    transform: "translate(-321.332 -157.765)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.571,159.494l1-.32.319,1.06-1,.319Z",
    transform: "translate(-326.234 -156.199)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.934,155.231l1-.32.32,1.06-1,.319Z",
    transform: "translate(-333.59 -153.853)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.2,174.64l1-.319.321,1.058-1,.319Z",
    transform: "translate(-304.561 -164.538)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.654,173.22l1-.319.32,1.058-1,.319Z",
    transform: "translate(-307.013 -163.756)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.88,172.509l1-.32.318,1.058-1,.32Z",
    transform: "translate(-308.239 -163.364)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.111,171.8l1-.319.32,1.058-1,.319Z",
    transform: "translate(-309.467 -162.973)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.563,170.377l1-.319.32,1.059-1,.319Z",
    transform: "translate(-311.918 -162.191)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.013,168.956l1-.32.322,1.058-1,.32Z",
    transform: "translate(-314.367 -161.409)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.241,168.246l1-.319.319,1.058-1,.319Z",
    transform: "translate(-315.594 -161.018)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.693,166.824l1-.319.319,1.058-1,.319Z",
    transform: "translate(-318.045 -160.235)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.923,166.114l1-.319.321,1.058-1,.319Z",
    transform: "translate(-319.272 -159.845)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.148,165.4l1-.32.319,1.059-1,.319Z",
    transform: "translate(-320.497 -159.453)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.376,164.693l1-.319.32,1.058-1,.32Z",
    transform: "translate(-321.723 -159.062)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.6,163.983l1-.319.32,1.058-1,.319Z",
    transform: "translate(-322.949 -158.671)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.829,163.272l1-.32.321,1.058-1,.32Z",
    transform: "translate(-324.175 -158.279)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.283,161.851l1-.319.321,1.058-1,.321Z",
    transform: "translate(-326.627 -157.497)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.736,160.43l1-.321.32,1.058-1,.32Z",
    transform: "translate(-329.078 -156.715)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.961,159.719l1-.319.32,1.058-1,.319Z",
    transform: "translate(-330.303 -156.324)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.189,159.008l1-.32.319,1.059-1,.319Z",
    transform: "translate(-331.529 -155.932)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.643,157.588l1-.319.32,1.058-1,.319Z",
    transform: "translate(-333.981 -155.151)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.913,176.994l1-.319.32,1.059-1,.319Z",
    transform: "translate(-304.954 -165.834)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.363,175.574l1-.319.319,1.059-1,.319Z",
    transform: "translate(-307.404 -165.052)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.591,174.863l1-.32.32,1.059-1,.32Z",
    transform: "translate(-308.63 -164.66)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.819,174.152l1-.319.32,1.059-1,.319Z",
    transform: "translate(-309.857 -164.269)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.27,172.731l1-.319.32,1.058-1,.32Z",
    transform: "translate(-312.307 -163.487)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.4,169.178l1-.319.32,1.059-1,.319Z",
    transform: "translate(-318.436 -161.531)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.632,168.468l1-.319.319,1.059-1,.319Z",
    transform: "translate(-319.662 -161.14)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.862,167.758l1-.319.319,1.059-1,.32Z",
    transform: "translate(-320.89 -160.75)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.992,164.2l1-.321.318,1.059-1,.32Z",
    transform: "translate(-327.017 -158.793)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.448,162.784l1-.32.32,1.059-1,.32Z",
    transform: "translate(-329.47 -158.011)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.672,162.073l1-.319.318,1.059-1,.319Z",
    transform: "translate(-330.694 -157.62)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.9,161.363l1-.319.319,1.059-1,.32Z",
    transform: "translate(-331.921 -157.229)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.354,159.942l1-.319.32,1.059-1,.319Z",
    transform: "translate(-334.372 -156.447)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.622,179.35l1-.319.319,1.058-1,.32Z",
    transform: "translate(-305.344 -167.131)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.074,177.929l1-.319.32,1.058-1,.319Z",
    transform: "translate(-307.795 -166.348)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.3,177.218l1-.32.319,1.058-1,.32Z",
    transform: "translate(-309.021 -165.957)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.531,176.507l1-.319.318,1.058-1,.319Z",
    transform: "translate(-310.249 -165.566)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.979,175.087l1-.32.319,1.058-1,.32Z",
    transform: "translate(-312.697 -164.783)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.436,173.666l1-.32.32,1.059-1,.32Z",
    transform: "translate(-315.15 -164.001)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.664,172.955l1-.319.32,1.059-1,.319Z",
    transform: "translate(-316.377 -163.61)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.888,172.244l1-.319.318,1.059-1,.319Z",
    transform: "translate(-317.601 -163.219)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.117,171.534l1-.319.32,1.059-1,.319Z",
    transform: "translate(-318.828 -162.828)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.571,170.114l1-.32.32,1.058-1,.32Z",
    transform: "translate(-321.28 -162.046)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.8,169.4l1-.32.319,1.058-1,.319Z",
    transform: "translate(-322.505 -161.654)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.25,167.981l1-.32.319,1.059-1,.32Z",
    transform: "translate(-324.957 -160.872)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.707,166.56l1-.32.319,1.059-1,.32Z",
    transform: "translate(-327.41 -160.089)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.159,165.14l1-.32.32,1.059-1,.319Z",
    transform: "translate(-329.861 -159.308)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.383,164.429l1-.319.321,1.058-1,.32Z",
    transform: "translate(-331.085 -158.917)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.61,163.719l1-.32.32,1.058-1,.319Z",
    transform: "translate(-332.312 -158.526)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.064,162.3l1-.319.32,1.058-1,.319Z",
    transform: "translate(-334.763 -157.744)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.334,181.7l1-.32.319,1.059-1,.32Z",
    transform: "translate(-305.736 -168.426)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.692,177.441l1-.32.32,1.059-1,.32Z",
    transform: "translate(-313.089 -166.079)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.826,173.889l1-.319.318,1.058-1,.32Z",
    transform: "translate(-319.218 -164.124)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.056,173.179l1-.319.32,1.058-1,.319Z",
    transform: "translate(-320.446 -163.733)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.281,172.467l1-.32.319,1.059-1,.319Z",
    transform: "translate(-321.671 -163.341)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.416,168.915l1-.32.321,1.058-1,.32Z",
    transform: "translate(-327.801 -161.386)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.775,164.652l1-.319.32,1.058-1,.32Z",
    transform: "translate(-335.155 -159.04)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.043,184.06l1-.32.321,1.059-1,.319Z",
    transform: "translate(-306.126 -169.723)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.27,183.35l1-.319.32,1.058-1,.319Z",
    transform: "translate(-307.352 -169.333)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.5,182.639l1-.32.32,1.059-1,.32Z",
    transform: "translate(-308.578 -168.941)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.724,181.929l1-.319.319,1.058-1,.319Z",
    transform: "translate(-309.804 -168.55)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.952,181.218l1-.32.32,1.058-1,.32Z",
    transform: "translate(-311.03 -168.159)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.177,180.508l1-.319.319,1.058-1,.319Z",
    transform: "translate(-312.255 -167.768)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.405,179.8l1-.32.32,1.059-1,.319Z",
    transform: "translate(-313.482 -167.376)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.857,178.376l1-.32.319,1.058-1,.32Z",
    transform: "translate(-315.933 -166.594)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.312,176.955l1-.319.32,1.058-1,.319Z",
    transform: "translate(-318.385 -165.813)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.764,175.533l1-.319.319,1.058-1,.32Z",
    transform: "translate(-320.836 -165.03)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.218,174.112l1-.32.32,1.058-1,.32Z",
    transform: "translate(-323.288 -164.247)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.673,172.691l1-.32.32,1.058-1,.319Z",
    transform: "translate(-325.74 -163.465)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.127,171.269l1-.32.319,1.059-1,.319Z",
    transform: "translate(-328.192 -162.682)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.355,170.559l1-.318.32,1.058-1,.32Z",
    transform: "translate(-329.418 -162.292)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.579,169.849l1-.319.319,1.059-1,.318Z",
    transform: "translate(-330.643 -161.901)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.807,169.139l1-.32.32,1.058-1,.32Z",
    transform: "translate(-331.869 -161.509)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.031,168.429l1-.319.32,1.058-1,.319Z",
    transform: "translate(-333.094 -161.119)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.259,167.718l1-.32.319,1.058-1,.319Z",
    transform: "translate(-334.32 -160.727)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.487,167.007l1-.32.32,1.059-1,.319Z",
    transform: "translate(-335.546 -160.336)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.476,177.888l1-.32.32,1.059-1,.319Z",
    transform: "translate(-321.228 -166.325)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.7,177.177l1-.319.319,1.059-1,.319Z",
    transform: "translate(-322.454 -165.934)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.385,175.046l1-.319.32,1.059-1,.319Z",
    transform: "translate(-326.132 -164.761)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.463,188.771l1-.32.318,1.058-1,.32Z",
    transform: "translate(-306.908 -172.316)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.145,186.639l1-.319.32,1.059-1,.318Z",
    transform: "translate(-310.586 -171.143)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.373,185.928l1-.32.319,1.058-1,.32Z",
    transform: "translate(-311.813 -170.751)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.6,185.218l1-.319.32,1.058-1,.319Z",
    transform: "translate(-313.039 -170.361)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.827,184.507l1-.32.32,1.059-1,.32Z",
    transform: "translate(-314.265 -169.969)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.051,183.8l1-.319.32,1.059-1,.319Z",
    transform: "translate(-315.489 -169.579)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.279,183.086l1-.32.32,1.059-1,.32Z",
    transform: "translate(-316.715 -169.187)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.734,181.665l1-.319.319,1.059-1,.32Z",
    transform: "translate(-319.168 -168.405)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.866,178.113l1-.319.319,1.059-1,.319Z",
    transform: "translate(-325.296 -166.45)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.094,177.4l1-.319.319,1.058-1,.32Z",
    transform: "translate(-326.522 -166.059)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.321,176.692l1-.319.321,1.058-1,.32Z",
    transform: "translate(-327.749 -165.667)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,174.56l1-.319.32,1.058-1,.319Z",
    transform: "translate(-331.426 -164.494)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.454,173.139l1-.319.32,1.057-1,.32Z",
    transform: "translate(-333.877 -163.712)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.683,172.429l1-.319.319,1.058-1,.318Z",
    transform: "translate(-335.104 -163.321)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.907,171.718l1-.32.319,1.058-1,.32Z",
    transform: "translate(-336.328 -162.929)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.4,190.414l1-.319.319,1.059-1,.319Z",
    transform: "translate(-308.526 -173.221)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.631,189.7l1-.32.32,1.059-1,.319Z",
    transform: "translate(-309.753 -172.83)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.085,188.283l1-.32.32,1.059-1,.319Z",
    transform: "translate(-312.205 -172.047)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.31,187.572l1-.319.319,1.059-1,.319Z",
    transform: "translate(-313.43 -171.657)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.763,186.152l1-.319.318,1.059-1,.318Z",
    transform: "translate(-315.881 -170.875)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.9,182.6l1-.32.32,1.059-1,.319Z",
    transform: "translate(-322.011 -168.919)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.122,181.889l1-.319.319,1.058-1,.32Z",
    transform: "translate(-323.235 -168.528)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.353,181.178l1-.319.321,1.058-1,.319Z",
    transform: "translate(-324.463 -168.137)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.576,180.468l1-.319.32,1.058-1,.32Z",
    transform: "translate(-325.687 -167.746)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.03,179.046l1-.32.319,1.058-1,.32Z",
    transform: "translate(-328.139 -166.963)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.485,177.624l1-.319.319,1.059-1,.32Z",
    transform: "translate(-330.591 -166.181)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.713,176.914l1-.319.32,1.059-1,.319Z",
    transform: "translate(-331.817 -165.79)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.938,176.2l1-.319.319,1.058-1,.32Z",
    transform: "translate(-333.042 -165.399)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.164,175.493l1-.32.318,1.059-1,.319Z",
    transform: "translate(-334.268 -165.007)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.394,174.783l1-.318.32,1.059-1,.319Z",
    transform: "translate(-335.495 -164.617)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.34,192.059l1-.319.32,1.058-1,.32Z",
    transform: "translate(-310.143 -174.127)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.022,189.928l1-.319.319,1.059-1,.319Z",
    transform: "translate(-313.821 -172.954)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.248,189.217l1-.32.32,1.059-1,.32Z",
    transform: "translate(-315.047 -172.562)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.7,187.8l1-.32.32,1.059-1,.32Z",
    transform: "translate(-317.497 -171.78)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.155,186.376l1-.319.32,1.058-1,.32Z",
    transform: "translate(-319.95 -170.998)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.38,185.665l1-.32.32,1.059-1,.319Z",
    transform: "translate(-321.175 -170.606)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.608,184.954l1-.319.321,1.059-1,.319Z",
    transform: "translate(-322.402 -170.216)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.835,184.244l1-.32.318,1.059-1,.319Z",
    transform: "translate(-323.627 -169.824)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.289,182.822l1-.32.319,1.059-1,.32Z",
    transform: "translate(-326.079 -169.042)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.516,182.111l1-.32.32,1.059-1,.319Z",
    transform: "translate(-327.305 -168.65)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.969,180.691l1-.319.319,1.059-1,.318Z",
    transform: "translate(-329.757 -167.869)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.2,179.98l1-.32.318,1.059-1,.32Z",
    transform: "translate(-330.983 -167.477)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.649,178.559l1-.32.32,1.059-1,.32Z",
    transform: "translate(-333.434 -166.695)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.329,176.428l1-.32.319,1.059-1,.32Z",
    transform: "translate(-337.111 -165.521)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.828,195.125l1-.319.32,1.059-1,.32Z",
    transform: "translate(-309.311 -175.814)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.05,194.414l1-.32.319,1.059-1,.32Z",
    transform: "translate(-310.534 -175.423)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.733,192.283l1-.319.32,1.059-1,.319Z",
    transform: "translate(-314.213 -174.25)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.64,189.441l1-.319.32,1.059-1,.32Z",
    transform: "translate(-319.116 -172.686)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.864,188.73l1-.32.319,1.059-1,.319Z",
    transform: "translate(-320.341 -172.294)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.092,188.02l1-.319.32,1.059-1,.32Z",
    transform: "translate(-321.567 -171.903)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.907,182.337l1-.32.321,1.059-1,.32Z",
    transform: "translate(-331.374 -168.775)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.362,180.915l1-.32.32,1.06-1,.318Z",
    transform: "translate(-333.826 -167.991)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.585,180.2l1-.318.319,1.058-1,.32Z",
    transform: "translate(-335.05 -167.601)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.815,179.495l1-.319.32,1.058-1,.319Z",
    transform: "translate(-336.278 -167.21)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.04,178.784l1-.32.319,1.058-1,.32Z",
    transform: "translate(-337.502 -166.819)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.307,198.191l1-.319.321,1.058-1,.319Z",
    transform: "translate(-308.473 -177.503)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.989,196.06l1-.319.32,1.058-1,.319Z",
    transform: "translate(-312.152 -176.329)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.442,194.639l1-.319.32,1.058-1,.319Z",
    transform: "translate(-314.603 -175.547)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.67,193.928l1-.32.319,1.059-1,.319Z",
    transform: "translate(-315.83 -175.155)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.9,193.218l1-.319.32,1.059-1,.319Z",
    transform: "translate(-317.055 -174.765)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.121,192.508l1-.319.319,1.058-1,.32Z",
    transform: "translate(-318.28 -174.374)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.576,191.087l1-.319.32,1.058-1,.319Z",
    transform: "translate(-320.733 -173.592)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.711,187.533l1-.319.32,1.059-1,.319Z",
    transform: "translate(-326.862 -171.635)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.935,186.822l1-.32.319,1.058-1,.32Z",
    transform: "translate(-328.087 -171.244)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.392,185.4l1-.319.319,1.058-1,.319Z",
    transform: "translate(-330.54 -170.463)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.751,181.138l1-.32.319,1.059-1,.319Z",
    transform: "translate(-337.894 -168.115)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.476,199.125l1-.319.32,1.059-1,.319Z",
    transform: "translate(-311.319 -178.016)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.93,197.7l1-.32.32,1.059-1,.32Z",
    transform: "translate(-313.771 -177.234)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.154,196.993l1-.319.319,1.058-1,.319Z",
    transform: "translate(-314.995 -176.843)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.833,194.862l1-.32.32,1.059-1,.32Z",
    transform: "translate(-318.672 -175.669)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.741,192.019l1-.32.319,1.059-1,.32Z",
    transform: "translate(-323.576 -174.104)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.968,191.308l1-.32.319,1.059-1,.319Z",
    transform: "translate(-324.801 -173.713)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.2,190.6l1-.319.32,1.058-1,.32Z",
    transform: "translate(-326.028 -173.323)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.421,189.888l1-.319.319,1.059-1,.319Z",
    transform: "translate(-327.253 -172.931)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.648,189.177l1-.32.319,1.059-1,.319Z",
    transform: "translate(-328.479 -172.54)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.875,188.467l1-.319.32,1.06-1,.319Z",
    transform: "translate(-329.705 -172.149)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.556,186.335l1-.319.32,1.059-1,.319Z",
    transform: "translate(-333.382 -170.975)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.237,184.2l1-.319.319,1.058-1,.32Z",
    transform: "translate(-337.06 -169.802)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.865,199.348l1-.319.32,1.059-1,.319Z",
    transform: "translate(-315.387 -178.139)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.09,198.638l1-.319.321,1.059-1,.319Z",
    transform: "translate(-316.612 -177.748)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.771,196.506l1-.32.319,1.059-1,.32Z",
    transform: "translate(-320.289 -176.574)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,195.8l1-.319.317,1.059-1,.318Z",
    transform: "translate(-321.515 -176.184)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.133,192.243l1-.319.322,1.059-1,.319Z",
    transform: "translate(-327.645 -174.228)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.357,191.533l1-.319.319,1.058-1,.32Z",
    transform: "translate(-328.869 -173.837)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.585,190.823l1-.319.32,1.058-1,.319Z",
    transform: "translate(-330.096 -173.447)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.811,190.113l1-.32.321,1.059-1,.319Z",
    transform: "translate(-331.321 -173.055)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.265,188.691l1-.319.32,1.058-1,.319Z",
    transform: "translate(-333.773 -172.273)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.493,187.981l1-.319.32,1.058-1,.319Z",
    transform: "translate(-334.999 -171.882)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.721,187.27l1-.32.32,1.058-1,.32Z",
    transform: "translate(-336.226 -171.49)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.946,186.558l1-.32.32,1.059-1,.319Z",
    transform: "translate(-337.451 -171.098)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.172,185.848l1-.319.319,1.058-1,.32Z",
    transform: "translate(-338.676 -170.708)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.668,204.546l1-.319.32,1.059-1,.318Z",
    transform: "translate(-310.874 -181.001)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.894,203.836l1-.319.32,1.058-1,.32Z",
    transform: "translate(-312.1 -180.61)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.121,203.125l1-.32.32,1.059-1,.319Z",
    transform: "translate(-313.325 -180.218)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.348,202.414l1-.32.32,1.059-1,.32Z",
    transform: "translate(-314.552 -179.827)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.708,198.152l1-.318.32,1.058-1,.319Z",
    transform: "translate(-321.906 -177.481)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.164,196.73l1-.32.32,1.059-1,.32Z",
    transform: "translate(-324.359 -176.697)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.844,194.6l1-.319.319,1.058-1,.32Z",
    transform: "translate(-328.036 -175.525)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.072,193.888l1-.32.32,1.059-1,.319Z",
    transform: "translate(-329.263 -175.133)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.3,193.177l1-.319.319,1.059-1,.319Z",
    transform: "translate(-330.487 -174.742)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.752,191.756l1-.32.319,1.059-1,.319Z",
    transform: "translate(-332.94 -173.96)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.2,190.335l1-.319.317,1.059-1,.319Z",
    transform: "translate(-335.391 -173.178)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.434,189.624l1-.32.319,1.059-1,.32Z",
    transform: "translate(-336.618 -172.786)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.884,188.2l1-.32.319,1.059-1,.32Z",
    transform: "translate(-339.068 -172.004)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.38,206.9l1-.318.32,1.058-1,.319Z",
    transform: "translate(-311.267 -182.298)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.834,205.481l1-.319.319,1.058-1,.319Z",
    transform: "translate(-313.718 -181.515)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.512,203.349l1-.318.32,1.058-1,.319Z",
    transform: "translate(-317.394 -180.342)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.418,200.506l1-.319.32,1.059-1,.319Z",
    transform: "translate(-322.297 -178.777)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.646,199.8l1-.319.321,1.058-1,.319Z",
    transform: "translate(-323.523 -178.386)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.871,199.086l1-.32.319,1.058-1,.32Z",
    transform: "translate(-324.748 -177.995)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.1,198.376l1-.319.32,1.058-1,.319Z",
    transform: "translate(-325.976 -177.604)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.556,196.953l1-.32.319,1.058-1,.32Z",
    transform: "translate(-328.428 -176.821)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.783,196.243l1-.319.319,1.058-1,.319Z",
    transform: "translate(-329.654 -176.43)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.007,195.533l1-.319.318,1.059-1,.319Z",
    transform: "translate(-330.879 -176.039)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.233,194.822l1-.32.319,1.059-1,.32Z",
    transform: "translate(-332.104 -175.647)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.46,194.112l1-.319.32,1.058-1,.32Z",
    transform: "translate(-333.33 -175.257)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.688,193.4l1-.32.32,1.058-1,.319Z",
    transform: "translate(-334.556 -174.865)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.139,191.981l1-.32.32,1.059-1,.319Z",
    transform: "translate(-337.006 -174.083)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.367,191.27l1-.319.318,1.058-1,.32Z",
    transform: "translate(-338.233 -173.692)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.675,204.282l1-.319.319,1.059-1,.32Z",
    transform: "translate(-320.236 -180.855)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.906,203.572l1-.32.32,1.06-1,.319Z",
    transform: "translate(-321.465 -180.464)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.131,202.862l1-.319.32,1.059-1,.32Z",
    transform: "translate(-322.69 -180.074)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.358,202.152l1-.319.319,1.059-1,.319Z",
    transform: "translate(-323.915 -179.682)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.811,200.729l1-.319.32,1.06-1,.319Z",
    transform: "translate(-326.367 -178.9)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.268,199.308l1-.32.319,1.06-1,.32Z",
    transform: "translate(-328.82 -178.117)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.493,198.6l1-.319.321,1.06-1,.319Z",
    transform: "translate(-330.045 -177.726)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.4,195.755l1-.319.319,1.06-1,.32Z",
    transform: "translate(-334.949 -176.161)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.853,194.335l1-.319.319,1.059-1,.32Z",
    transform: "translate(-337.399 -175.38)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.079,193.625l1-.32.32,1.059-1,.319Z",
    transform: "translate(-338.625 -174.988)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.572,212.323l1-.32.32,1.059-1,.32Z",
    transform: "translate(-310.821 -185.281)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.8,211.611l1-.319.321,1.059-1,.32Z",
    transform: "translate(-312.05 -184.89)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.026,210.9l1-.319.32,1.058-1,.319Z",
    transform: "translate(-313.274 -184.499)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.253,210.191l1-.32.321,1.059-1,.319Z",
    transform: "translate(-314.5 -184.108)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.481,209.481l1-.318.32,1.058-1,.319Z",
    transform: "translate(-315.726 -183.718)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.709,208.77l1-.32.319,1.059-1,.32Z",
    transform: "translate(-316.952 -183.325)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.935,208.06l1-.319.319,1.059-1,.319Z",
    transform: "translate(-318.177 -182.935)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.386,206.64l1-.32.319,1.059-1,.319Z",
    transform: "translate(-320.628 -182.153)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.843,205.218l1-.32.318,1.058-1,.32Z",
    transform: "translate(-323.081 -181.37)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.295,203.8l1-.32.32,1.058-1,.32Z",
    transform: "translate(-325.532 -180.588)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.2,200.955l1-.319.319,1.058-1,.319Z",
    transform: "translate(-330.435 -179.024)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.654,199.535l1-.319.32,1.058-1,.319Z",
    transform: "translate(-332.886 -178.242)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.11,198.113l1-.32.32,1.058-1,.32Z",
    transform: "translate(-335.339 -177.459)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.016,195.271l1-.319.321,1.058-1,.32Z",
    transform: "translate(-340.242 -175.895)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.284,214.678l1-.32.319,1.058-1,.32Z",
    transform: "translate(-311.214 -186.578)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.645,210.415l1-.319.318,1.059-1,.319Z",
    transform: "translate(-318.568 -184.232)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.1,208.994l1-.319.32,1.058-1,.32Z",
    transform: "translate(-321.021 -183.449)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.777,206.862l1-.319.32,1.059-1,.318Z",
    transform: "translate(-324.697 -182.275)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.232,205.441l1-.319.318,1.059-1,.318Z",
    transform: "translate(-327.149 -181.493)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.689,204.019l1-.32.32,1.059-1,.319Z",
    transform: "translate(-329.603 -180.71)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.913,203.308l1-.319.32,1.058-1,.32Z",
    transform: "translate(-330.827 -180.319)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.821,200.467l1-.32.319,1.059-1,.319Z",
    transform: "translate(-335.73 -178.755)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.728,197.625l1-.32.32,1.058-1,.32Z",
    transform: "translate(-340.634 -177.19)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,217.032l1-.32.32,1.059-1,.319Z",
    transform: "translate(-311.606 -187.874)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.449,215.612l1-.319.32,1.059-1,.318Z",
    transform: "translate(-314.057 -187.092)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.676,214.9l1-.32.319,1.059-1,.32Z",
    transform: "translate(-315.282 -186.7)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.9,214.191l1-.319.32,1.058-1,.319Z",
    transform: "translate(-316.509 -186.31)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.355,212.77l1-.319.322,1.057-1,.319Z",
    transform: "translate(-318.96 -185.528)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.809,211.348l1-.32.319,1.058-1,.319Z",
    transform: "translate(-321.411 -184.745)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.263,209.926l1-.32.32,1.058-1,.32Z",
    transform: "translate(-323.863 -183.962)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.488,209.217l1-.318.319,1.058-1,.319Z",
    transform: "translate(-325.088 -183.572)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.718,208.506l1-.32.321,1.059-1,.32Z",
    transform: "translate(-326.316 -183.18)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.168,207.085l1-.32.319,1.058-1,.32Z",
    transform: "translate(-328.765 -182.398)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.4,206.374l1-.319.32,1.059-1,.319Z",
    transform: "translate(-329.993 -182.007)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.624,205.663l1-.32.32,1.059-1,.319Z",
    transform: "translate(-331.218 -181.615)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.851,204.953l1-.319.319,1.059-1,.319Z",
    transform: "translate(-332.444 -181.225)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.078,204.243l1-.32.319,1.059-1,.32Z",
    transform: "translate(-333.67 -180.833)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.306,203.532l1-.319.32,1.059-1,.319Z",
    transform: "translate(-334.896 -180.443)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.53,202.822l1-.319.32,1.058-1,.32Z",
    transform: "translate(-336.121 -180.052)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.706,219.387l1-.319.32,1.059-1,.319Z",
    transform: "translate(-311.996 -189.17)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.161,217.966l1-.318.32,1.059-1,.318Z",
    transform: "translate(-314.449 -188.389)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.387,217.256l1-.32.32,1.059-1,.32Z",
    transform: "translate(-315.674 -187.997)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.613,216.545l1-.319.32,1.059-1,.32Z",
    transform: "translate(-316.899 -187.606)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.067,215.123l1-.319.319,1.059-1,.319Z",
    transform: "translate(-319.351 -186.823)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.521,213.7l1-.319.32,1.059-1,.32Z",
    transform: "translate(-321.803 -186.041)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.746,212.992l1-.319.319,1.059-1,.319Z",
    transform: "translate(-323.028 -185.65)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.973,212.281l1-.32.32,1.06-1,.319Z",
    transform: "translate(-324.254 -185.258)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.427,210.861l1-.32.32,1.06-1,.319Z",
    transform: "translate(-326.706 -184.476)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.655,210.15l1-.319.319,1.059-1,.32Z",
    transform: "translate(-327.932 -184.086)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.879,209.439l1-.32.319,1.059-1,.32Z",
    transform: "translate(-329.157 -183.694)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.788,206.6l1-.32.32,1.059-1,.32Z",
    transform: "translate(-334.061 -182.13)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.922,203.045l1-.32.319,1.059-1,.32Z",
    transform: "translate(-340.19 -180.174)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.149,202.334l1-.319.32,1.059-1,.319Z",
    transform: "translate(-341.416 -179.783)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.415,221.744l1-.319.319,1.058-1,.32Z",
    transform: "translate(-312.386 -190.468)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.874,220.322l1-.318.319,1.058-1,.32Z",
    transform: "translate(-314.841 -189.686)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.1,219.612l1-.32.32,1.059-1,.32Z",
    transform: "translate(-316.066 -189.294)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.325,218.9l1-.32.319,1.059-1,.319Z",
    transform: "translate(-317.291 -188.902)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.778,217.48l1-.319.318,1.059-1,.32Z",
    transform: "translate(-319.743 -188.121)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.913,213.927l1-.32.319,1.059-1,.318Z",
    transform: "translate(-325.872 -186.165)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.274,209.665l1-.319.318,1.058-1,.319Z",
    transform: "translate(-333.228 -183.818)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.952,207.533l1-.319.32,1.058-1,.319Z",
    transform: "translate(-336.903 -182.645)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.178,206.822l1-.32.321,1.059-1,.319Z",
    transform: "translate(-338.129 -182.253)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.4,206.111l1-.319.319,1.059-1,.32Z",
    transform: "translate(-339.355 -181.862)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.633,205.4l1-.32.32,1.06-1,.319Z",
    transform: "translate(-340.581 -181.47)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.859,204.69l1-.319.32,1.059-1,.32Z",
    transform: "translate(-341.807 -181.08)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.129,224.1l1-.32.319,1.059-1,.319Z",
    transform: "translate(-312.78 -191.763)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.489,219.836l1-.32.32,1.058-1,.32Z",
    transform: "translate(-320.134 -189.417)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.17,217.7l1-.319.32,1.058-1,.319Z",
    transform: "translate(-323.812 -188.244)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.394,216.992l1-.321.319,1.06-1,.319Z",
    transform: "translate(-325.036 -187.851)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.3,214.151l1-.32.32,1.059-1,.32Z",
    transform: "translate(-329.94 -186.288)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.437,210.6l1-.32.32,1.059-1,.319Z",
    transform: "translate(-336.069 -184.331)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.665,209.887l1-.319.32,1.058-1,.32Z",
    transform: "translate(-337.296 -183.941)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.119,208.467l1-.32.319,1.059-1,.319Z",
    transform: "translate(-339.747 -183.159)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.343,207.757l1-.319.319,1.058-1,.319Z",
    transform: "translate(-340.972 -182.768)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.57,207.046l1-.32.321,1.058-1,.32Z",
    transform: "translate(-342.198 -182.377)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.839,226.453l1-.319.321,1.059-1,.319Z",
    transform: "translate(-313.17 -193.06)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.064,225.743l1-.319.32,1.058-1,.32Z",
    transform: "translate(-314.396 -192.669)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.293,225.032l1-.32.321,1.059-1,.32Z",
    transform: "translate(-315.622 -192.277)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.517,224.321l1-.319.32,1.058-1,.32Z",
    transform: "translate(-316.846 -191.886)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.748,223.61l1-.32.319,1.06-1,.319Z",
    transform: "translate(-318.075 -191.494)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.976,222.9l1-.318.32,1.059-1,.319Z",
    transform: "translate(-319.301 -191.105)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.2,222.19l1-.32.32,1.059-1,.32Z",
    transform: "translate(-320.524 -190.713)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.652,220.769l1-.32.32,1.059-1,.32Z",
    transform: "translate(-322.976 -189.931)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.107,219.348l1-.319.319,1.058-1,.32Z",
    transform: "translate(-325.429 -189.149)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.562,217.926l1-.32.32,1.059-1,.319Z",
    transform: "translate(-327.881 -188.366)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.012,216.506l1-.32.32,1.059-1,.319Z",
    transform: "translate(-330.33 -187.584)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.468,215.086l1-.318.32,1.058-1,.319Z",
    transform: "translate(-332.784 -186.803)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.694,214.375l1-.32.32,1.058-1,.32Z",
    transform: "translate(-334.009 -186.411)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.6,211.532l1-.319.32,1.059-1,.32Z",
    transform: "translate(-338.913 -184.846)",
    fill: "#66c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.28,209.4l1-.32.319,1.059-1,.319Z",
    transform: "translate(-342.589 -183.673)",
    fill: "#66c8ff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M284.629,163.375l1.39-.444-2.028-6.715,6.349-2.025-.445-1.471-7.738,2.47Z",
    transform: "translate(-282.158 -142.505)",
    fill: "#406493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.391,132.462l.444,1.47,6.349-2.025,2.026,6.715,1.39-.444-2.471-8.184Z",
    transform: "translate(-321.371 -129.994)",
    fill: "#406493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.986,212.492l-6.349,2.025.443,1.471,7.741-2.469-2.471-8.185-1.389.443Z",
    transform: "translate(-336.369 -171.467)",
    fill: "#406493"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.288,232.569l-1.389.444,2.47,8.186,7.739-2.47-.444-1.47-6.348,2.025Z",
    transform: "translate(-294.677 -186.46)",
    fill: "#406493"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(21.056 50.609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M334.942,173.152l-39.612,12.64-.363-1.2,39.614-12.64Z",
    transform: "translate(-294.968 -171.955)",
    fill: "#33caff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.922,196.267l-39.613,12.64-6.534-21.649,39.612-12.64Z",
    transform: "translate(-295.412 -173.421)",
    fill: "url(#d)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-33.544 -31.787)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.612,211.25l-19.395-15.068L359.8,81.584,379.2,96.653Z",
    transform: "translate(-232.248 -39.811)",
    fill: "url(#e)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.656,142.911l-15.389-11.957,79.584-114.6,15.392,11.957Z",
    transform: "translate(-161.72 -3.904)",
    fill: "url(#f)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.23,180.653l-6.746-5.242,79.584-114.6,6.747,5.241Z",
    transform: "translate(-217.532 -28.377)",
    fill: "url(#g)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.765,105.01l-2.261-1.758,79.584-114.6,2.263,1.757Z",
    transform: "translate(-173.504 11.345)",
    fill: "url(#h)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.858,263.722l-1.837-1.428L389.6,147.7l1.837,1.428Z",
    transform: "translate(-248.654 -76.205)",
    fill: "url(#i)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.375 6.979)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M273.936,74.9l1.272,2.316s.988,1.846,3.55,1.029l21.7-6.923a2.938,2.938,0,0,0,2.361-2.916l-.227-2.649Z",
    transform: "translate(-273.936 -65.761)",
    fill: "#002776"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(10.517 4.266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M306.227,77.057a.611.611,0,0,1-.38.767L298.1,80.3a.591.591,0,0,1-.736-.411h0a.615.615,0,0,1,.379-.768l7.752-2.473a.59.59,0,0,1,.736.412Z",
    transform: "translate(-297.333 -76.003)",
    fill: "#005cb9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.643,75.626a.524.524,0,0,1-.324.657h0a.506.506,0,0,1-.631-.353h0a.526.526,0,0,1,.324-.658h0a.507.507,0,0,1,.631.354Z",
    transform: "translate(-309.626 -75.25)",
    fill: "#005cb9"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.131 54.887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M239.038,173.392c2.649-2.342,10.293-.815,14.127,4.907,3.4,5.071,3.784,11.811,4.29,14.36s4.392,11.536,4.694,12.916c.559,2.548,9.149,6.593,15.527,17.912s4.887,30.532-6.573,34.06-16.2-1.11-20.319-7.873-10.217-22.211-8.642-30.786c3.022-16.476,3.762-23.968,1.4-32.059S235.832,176.227,239.038,173.392Z",
    transform: "translate(-237.933 -172.338)",
    fill: "#ffc4a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.809,179.022c.252-2.154,2.857-2.264,4.1-1.519s5.345,5.789,5.232,8.246-4.014,4.732-4.427,3.478S237.557,181.175,237.809,179.022Z",
    transform: "translate(-237.799 -174.951)",
    fill: "#ffe8da"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.892,390.02A44.489,44.489,0,0,0,308.6,370.357a50.791,50.791,0,0,0,21.343-4.436,12.726,12.726,0,0,1-1.573,1.453Z",
    transform: "matrix(0.996, 0.087, -0.087, 0.996, -241.14, -251.404)",
    fill: "#f7aa8d"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.823 40.833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.31,142.622c-.487.382-2.458,3.489-.157,8.642s5.4,6.3,7.533,4.714a7.6,7.6,0,0,0,2.38-9.433c-.5-1.148-1.658-4.245-4.176-5.2S396.867,142.187,396.31,142.622Z",
    transform: "translate(-395.061 -141.073)",
    fill: "#ffc4a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404.139,143.3a9.594,9.594,0,0,1,3.764,3.731,19.526,19.526,0,0,1,2.1,6.039s2.083-1.54.4-5.227c-1.021-2.236-2.226-3.724-3.626-4.372A3.369,3.369,0,0,0,404.139,143.3Z",
    transform: "translate(-400.058 -142.193)",
    fill: "#ffe8da"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.084 18.709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M409.638,182.937c-.379.33-1.95,3.163-.311,8.239s3.931,7.12,5.705,5.792c3.015-2.256,2.216-8.82,1.389-11.433S410.4,182.27,409.638,182.937Z",
    transform: "translate(-408.595 -182.694)",
    fill: "#ffc4a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.066,189.212c-.575-2.224-1.471-3.8-2.715-4.644a3.532,3.532,0,0,0-2.539-.636,9.064,9.064,0,0,1,2.97,4.086,17.094,17.094,0,0,1,.914,5.886S422.017,192.878,421.066,189.212Z",
    transform: "translate(-412.568 -183.341)",
    fill: "#ffe8da"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.37 36.672)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M424.967,222.7c-1.863-.314-5.413,1.1-4.449,6.391s4.22,9.679,6.715,7.38,2.678-5.238,1.872-8.033S426.828,223.01,424.967,222.7Z",
    transform: "translate(-420.354 -222.654)",
    fill: "#ffc4a7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.467,230.12a6.648,6.648,0,0,0-2.816-4.237,4.19,4.19,0,0,0-2.716-.533,8.169,8.169,0,0,1,3.1,3.715,13.539,13.539,0,0,1,.853,5.427S432.407,233.491,431.467,230.12Z",
    transform: "translate(-423.426 -224.101)",
    fill: "#ffe8da"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(200.515 357.073)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.729 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.944 0) rotate(8)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.166,20.247c-5.354-7.145-8.555-7.2-12.017-6.735a6.086,6.086,0,0,0-4.686,3.3s-3.86-1.506-6.829-.609A7.065,7.065,0,0,0,46.49,19.96a10.675,10.675,0,0,0-6.663-.664,8.461,8.461,0,0,0-3.979,2.753S26.006,11.062,18.955,5.419C8.2-3.186.9-.237.068,5.253c-.346,2.292.539,5.353,4.664,8.61,4.759,3.759,9.813,9.176,12.888,12.161,3.552,3.448,9.671,13.022,10.167,15.393a25.919,25.919,0,0,1,.045,9.658,8.67,8.67,0,0,1-.49-.832c-1.667-3.3-5.761-15.513-10.866-17.59s-8.866,3.653-7.2,9.211c0,0,1.969,6.277,1.8,10.493S10.1,65.288,13.767,67.972,26.477,84.049,32.02,86.588s11.682,6.123,22.042,6,30.282-13.613,31.486-18.44.07-16.524-2.176-25.988C80.4,35.654,77.214,24.313,74.166,20.247Z",
    transform: "translate(0 3.345)",
    fill: "#f2f2f2",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.166,20.247c-5.355-7.145-8.556-7.2-12.018-6.736a6.087,6.087,0,0,0-4.686,3.3s-3.86-1.506-6.828-.609A7.065,7.065,0,0,0,46.49,19.96a10.676,10.676,0,0,0-6.663-.664,8.464,8.464,0,0,0-3.979,2.753S26.006,11.062,18.954,5.42C8.2-3.186.9-.237.068,5.253c-.346,2.292.539,5.353,4.664,8.61,4.759,3.759,9.813,9.176,12.888,12.161,3.552,3.449,9.671,13.022,10.167,15.393a25.923,25.923,0,0,1,.045,9.658,8.722,8.722,0,0,1-.49-.832c-1.667-3.3-5.761-15.513-10.867-17.59s-8.866,3.653-7.2,9.211c0,0,1.969,6.276,1.8,10.493S10.1,65.289,13.767,67.972,26.477,84.049,32.02,86.589c4.346,1.991,80.976,57.12,101.645,61.724,5.421,1.208,16.683-39.372,16.683-39.372L126.242,95.5,85.548,74.146s.07-16.524-2.176-25.988C80.4,35.654,77.213,24.313,74.166,20.247Z",
    transform: "translate(2.447 0)",
    fill: "#ffc4a7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.743,9.878S-.854,6.2.093,3.341,4.474-.485,7.335.223a13.643,13.643,0,0,1,5.388,3.254,17.161,17.161,0,0,0-4.6,2.76A12.49,12.49,0,0,0,5.743,9.878Z",
    transform: "translate(2.86 0.073)",
    fill: "#ffe8da"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M.46,2.018s1.9-2.7,4.516-1.853A7,7,0,0,1,9.046,4.209c.53,1.011,1.438,3.045,1.438,3.045A19.736,19.736,0,0,0,5.037,8.728a14.159,14.159,0,0,0-3.1,2.644S-1.136,4.7.46,2.018Z",
    transform: "translate(10.642 32.988)",
    fill: "#ffe8da"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.651 10.069)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.406,4.848A29.667,29.667,0,0,1,0,0,6.505,6.505,0,0,0,2.183,3.593C5.852,6.277,14.893,19.67,20.436,22.21s11.681,6.123,22.041,6c3.469-.041,8.009-1.582,12.559-3.793-7.292.615-15.135-.449-22.474-1.977C19.613,19.739,11.82,7.81,6.406,4.848Z",
    transform: "translate(10.379 54.31)",
    fill: "#f7aa8d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.582,31.348a26.249,26.249,0,0,1,.388,7.163c3.8-6.7-.171-11.989-1.2-14.765-1.139-3.068-9.192-11.011-10.452-12.718S10.334,7.808,5.834,5A31.072,31.072,0,0,1,0,0,14.8,14.8,0,0,0,3.527,3.794c4.759,3.759,9.813,9.176,12.888,12.161C19.967,19.4,26.086,28.978,26.582,31.348Z",
    fill: "#f7aa8d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.77,0A9.139,9.139,0,0,0,0,1.611,80.577,80.577,0,0,1,5.284,8.335,46.216,46.216,0,0,0,1.77,0Z",
    transform: "translate(34.739 10.251)",
    fill: "#f7aa8d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5,0A7.367,7.367,0,0,0,.007,2.135L0,2.132A85.171,85.171,0,0,1,6.286,8.747,46.069,46.069,0,0,0,1.5,0Z",
    transform: "translate(45.279 7.756)",
    fill: "#f7aa8d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.615,0A5.923,5.923,0,0,0,0,1.99,85.705,85.705,0,0,1,6.333,8.651,46.078,46.078,0,0,0,1.615,0Z",
    transform: "translate(56.263 4.745)",
    fill: "#f7aa8d"
  })))))))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(199.103 205.339)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1255.612-184l1.913-3.5,1.914,3.5a20.853,20.853,0,0,0,8.291,8.29l3.5,1.914-3.5,1.913a20.855,20.855,0,0,0-8.291,8.29l-1.914,3.5-1.913-3.5a20.858,20.858,0,0,0-8.291-8.29l-3.5-1.913,3.5-1.914A20.856,20.856,0,0,0,1255.612-184Z",
    transform: "translate(-1215.763 187.498)",
    fill: "#ff5490"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.307-166.9l.811-1.485.812,1.485a8.851,8.851,0,0,0,3.516,3.516l1.484.812-1.484.811a8.851,8.851,0,0,0-3.516,3.516l-.812,1.485-.811-1.485a8.839,8.839,0,0,0-3.516-3.516l-1.484-.811,1.484-.812A8.839,8.839,0,0,0,1212.307-166.9Z",
    transform: "translate(-1207.307 183.071)",
    fill: "#33caff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.162-114.146l.373-.683.374.683a4.071,4.071,0,0,0,1.618,1.619l.684.373-.684.374a4.066,4.066,0,0,0-1.618,1.619l-.374.683-.373-.683a4.069,4.069,0,0,0-1.619-1.619l-.683-.374.683-.373A4.073,4.073,0,0,0,1279.162-114.146Z",
    transform: "translate(-1223.414 170.669)",
    fill: "#ff5490"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.409-149.657l.682-1.246.682,1.246a7.428,7.428,0,0,0,2.952,2.952l1.246.681-1.246.682a7.423,7.423,0,0,0-2.952,2.952l-.682,1.246-.682-1.246a7.428,7.428,0,0,0-2.951-2.952l-1.246-.682,1.246-.681A7.433,7.433,0,0,0,1284.409-149.657Z",
    transform: "translate(-1224.19 179.023)",
    fill: "#7a87ff"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(45.948 94.635)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.328 85.1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-0.276 8.265)",
    fill: "#99d6ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(-0.276 0.265)",
    fill: "#99d6ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 12.515)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0.051 8.851)",
    fill: "#99d6ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(0.051 -0.15)",
    fill: "#99d6ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(279.078 51.31)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(-0.027 9.055)",
    fill: "#99d6ff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-0.027 0.055)",
    fill: "#99d6ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(190.224)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "translate(-0.172 8.365)",
    fill: "#99d6ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2,
    cy: 1.5,
    rx: 2,
    ry: 1.5,
    transform: "translate(-0.172 0.365)",
    fill: "#99d6ff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFound);
export default __webpack_public_path__ + "static/media/not_found.7e0c28ec5323f4c496025c8516b9dc8a.svg";
export { ForwardRef as ReactComponent };